<div class="header col-xs-12 col-sm-12 col-md-12">
	<div class="filter-heading text-left col-xs-6 px-0">Filters</div>
	<div class="text-right col-xs-6 px-0">
		<button [disabled]="isApplyBtnDisbaled" mat-button class="btn-apply" (click)="onApplyClicked()">Apply
		</button>
		<span class="spacer"></span>
		<button [disabled]="isClearBtnDisbaled" mat-button (click)="onClearClicked()">
			Clear
		</button>
	</div>
</div>

<div class="col-xs-12 col-sm-12 col-md-12 filter-items-spinner" *ngIf="spinner">
	<mat-progress-spinner color="accent" mode="indeterminate" value="30" diameter="70"></mat-progress-spinner>
</div>



<!-- <div class="px-0 col-xs-12 col-sm-12 col-md-12 filter-items" *ngIf="!spinner">
	<ng-container *ngFor="let filter of filters; let i = index">
		<ng-container *ngIf="filter.type === 'checkbox' && !filter.hasMultipleOptions">
			<app-light-checkbox [style.padding]="'10px 0 10px 10px'" [value]="filter.options.value"
				[text]="filter.options.label"
				(onChangeEvent)="handleCheckBoxEvent(filter.key, $event, filter.options.value, filter.hasMultipleOptions)"
				[checked]="selectedValue(filter.key, filter.type, filter.options.value, filter.hasMultipleOptions)"></app-light-checkbox>
		</ng-container>
		<mat-accordion *ngIf="filter.title">
			<mat-expansion-panel [expanded]="false">
				<mat-expansion-panel-header>
					<mat-panel-title>
						<label *ngIf="filter.title">{{filter.title | titlecase}}</label>
					</mat-panel-title>
				</mat-expansion-panel-header>
				<ng-container *ngIf="filter.type === 'radio' && filter.options.length">
					<app-radio-button class="border" [radioValue]="filter.options" [isRadioGroup]="true"
						(onChangeEvent)="handleRadioEvent(filter.key, $event)"
						[selectedValue]="selectedValue(filter.key, filter.type)"></app-radio-button>
				</ng-container>
				<ng-container *ngIf="filter.type === 'checkbox'">
					<ng-container *ngIf="filter.hasMultipleOptions">
						<ng-container *ngFor="let option of filter.options">
							<app-light-checkbox [style.padding-left]="'10px'" [value]="option.value"
								[text]="option.label"
								(onChangeEvent)="handleCheckBoxEvent(filter.key, $event, option.value, filter.hasMultipleOptions)"
								[checked]="selectedValue(filter.key, filter.type, option.value, filter.hasMultipleOptions)"></app-light-checkbox>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="!filter.hasMultipleOptions">
						<app-light-checkbox [style.padding-left]="'10px'" [value]="filter.options.value"
							[text]="filter.options.label"
							(onChangeEvent)="handleCheckBoxEvent(filter.key, $event, filter.options.value, filter.hasMultipleOptions)"
							[checked]="selectedValue(filter.key, filter.type, filter.options.value, filter.hasMultipleOptions)"></app-light-checkbox>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="filter.type === 'slider' && filter.options">
					<as-slider [sliderOptions]="filter.options"
						(onValueChange)="handleSliderChange(filter.key, $event)"></as-slider>
				</ng-container>
			</mat-expansion-panel>
		</mat-accordion>
	</ng-container>
</div>
 -->


<div class="px-0 col-xs-12 col-sm-12 col-md-12 filter-items" *ngIf="!spinner">
	<mat-accordion *ngIf="filters && filters.length > 0">
		<ng-container *ngFor="let filter of filters; let i = index">
			<ng-container *ngIf="filter.type === 'checkbox' && !filter.hasMultipleOptions">
				<app-light-checkbox [style.padding]="'10px 0 10px 10px'" [value]="filter.options.value"
					[text]="filter.options.label"
					(onChangeEvent)="handleCheckBoxEvent(filter.key, $event, filter.options.value, filter.hasMultipleOptions)"
					[checked]="selectedValue(filter.key, filter.type, filter.options.value, filter.hasMultipleOptions)">
				</app-light-checkbox>
			</ng-container>
			<mat-expansion-panel *ngIf="filter.title">
				<mat-expansion-panel-header>
					<mat-panel-title>
						<label *ngIf="filter.title">{{filter.title | titlecase}}</label>
					</mat-panel-title>
				</mat-expansion-panel-header>
				<ng-container *ngIf="filter.type === 'radio' && filter.options.length">
					<app-radio-button class="border" [radioValue]="filter.options" [isRadioGroup]="true"
						(onChangeEvent)="handleRadioEvent(filter.key, $event)"
						[selectedValue]="selectedValue(filter.key, filter.type)">
					</app-radio-button>
				</ng-container>
				<ng-container *ngIf="filter.type === 'checkbox'">
					<ng-container *ngIf="filter.hasMultipleOptions">
						<ng-container *ngFor="let option of filter.options">
							<app-light-checkbox [style.padding-left]="'10px'" [value]="option.value"
								[text]="option.label"
								(onChangeEvent)="handleCheckBoxEvent(filter.key, $event, option.value, filter.hasMultipleOptions)"
								[checked]="selectedValue(filter.key, filter.type, option.value, filter.hasMultipleOptions)"></app-light-checkbox>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="!filter.hasMultipleOptions">
						<app-light-checkbox [style.padding-left]="'10px'" [value]="filter.options.value"
							[text]="filter.options.label"
							(onChangeEvent)="handleCheckBoxEvent(filter.key, $event, filter.options.value, filter.hasMultipleOptions)"
							[checked]="selectedValue(filter.key, filter.type, filter.options.value, filter.hasMultipleOptions)"></app-light-checkbox>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="filter.type === 'slider' && filter.options">
					<as-slider [sliderOptions]="filter.options"
						(onValueChange)="handleSliderChange(filter.key, $event)"></as-slider>
				</ng-container>
			</mat-expansion-panel>
		</ng-container>
	</mat-accordion>
</div>